/* eslint-disable */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AppBar as MuiAppBar,
  Typography,
  Divider,
  Tooltip,
  Avatar,
} from "@mui/material";

import {
  Receipt as ReceiptIcon,
  ExpandMore as ExpandMoreIcon,
  Menu as MenuIcon,
  DonutSmall as DonutSmallIcon,
  // Cloud as CloudIcon,
  Whatshot as WhatshotIcon,
  /*   Person as PersonIcon, */
  Logout as LogoutIcon,
  StoreMallDirectory as StoreIcon,
} from "@mui/icons-material";
import { Outlet, useLocation } from "react-router-dom";

import { SubmenuKeys, useSidebar } from "context/SidebarContext";

import { getEnvironmentVariables } from "config/appConfig";
import { useAuth } from "react-oidc-context";

import * as Styled from "./styles";

interface SidebarItems {
  name: string;
  key: SubmenuKeys;
  isAccordion: boolean;
  path: string;
  items: { name: string; path: string }[] | null;
  icon: JSX.Element;
}

const Sidebar = () => {
  const {
    isSidebarMaximized,
    isSubmenuOpen,
    setIsSubmenuOpen,
    handleToggleSidebar,
  } = useSidebar();

  const auth = useAuth();

  const { t } = useTranslation();
  const { pathname } = useLocation();

  const [anchorElUser, setAnchorElUser] = useState<
    (EventTarget & HTMLElement) | null
  >(null);

  // Todo -> Pegar dados de user do Redux/Auth.
  const user = {
    name: "Daniel Cruz",
    logoUrl: null,
  };

  const { logoFull } = getEnvironmentVariables();

  const handleSignOut = () => {
    auth.signoutRedirect();
  };

  const sidebarItems: SidebarItems[] = [
    {
      name: t("orders"),
      key: "orders",
      isAccordion: true,
      path: "",
      items: [
        { name: t("manageOrders"), path: "orders/manage" },
        { name: t("scheduleOrders"), path: "orders/schedule" },
        { name: t("findOrders"), path: "dealers/find-orders" },
      ],
      icon: <ReceiptIcon />,
    },
    {
      name: t("dealers"),
      key: "dealers",
      path: "",
      isAccordion: true,
      items: [
        {
          name: t("manageDealers"),
          path: "/dealers/manage",
        },
      ],
      icon: <StoreIcon />,
    },
    // {
    //   name: t("reports"),
    //   key: "reports",
    //   isAccordion: true,
    //   path: "//",
    //   items: [
    //     { name: t("dashboard"), path: "//" },
    //     { name: t("balance"), path: "//" },
    //     { name: t("ordersHistory"), path: "//" },
    //   ],
    //   icon: <DonutSmallIcon />,
    // },
    {
      name: t("products"),
      key: "products",
      isAccordion: true,
      path: "//",
      items: [{ name: t("manageProducts"), path: "/products/manage" }],
      icon: <WhatshotIcon />,
    },
  ];

  const handleChangeSubmenuVisibility = (submenuName: SubmenuKeys) => {
    setIsSubmenuOpen((state) => ({
      ...state,
      [submenuName]: !state[submenuName],
    }));
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const getAvatarImgOrStringAvatar = (
    name: string,
    photoUrl?: string | null,
  ) => {
    if (photoUrl)
      return {
        src: photoUrl,
      };

    return {
      children: `${name.split(" ")[0][0]}`,
    };
  };

  return (
    <Styled.Container>
      <MuiAppBar position="fixed">
        <Styled.AppBar>
          <Styled.ToolbarLeftContainer>
            <Styled.HamburgerButton
              color="inherit"
              onClick={handleToggleSidebar}
              edge="start"
            >
              <MenuIcon />
            </Styled.HamburgerButton>

            <Styled.LogoFullImg src={logoFull} />
          </Styled.ToolbarLeftContainer>
          <Styled.UserMenuContainer>
            <Tooltip title={t("openSettings")}>
              <Styled.AvatarIconButton onClick={handleOpenUserMenu}>
                <Avatar
                  alt={user.name}
                  {...getAvatarImgOrStringAvatar(user.name)}
                />
              </Styled.AvatarIconButton>
            </Tooltip>
            <Styled.MenuContainer
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {/*       <Styled.UserMenuItem onClick={() => {}}>
                <PersonIcon />
                <Typography textAlign="center">{t("myAccount")}</Typography>
              </Styled.UserMenuItem> */}

              <Styled.UserMenuItem onClick={handleSignOut}>
                <LogoutIcon />
                <Typography textAlign="center">{t("logout")}</Typography>
              </Styled.UserMenuItem>
            </Styled.MenuContainer>
          </Styled.UserMenuContainer>
        </Styled.AppBar>
      </MuiAppBar>
      <Styled.DrawerNav
        variant="persistent"
        anchor="left"
        open={isSidebarMaximized}
      >
        {/* TODO -> NOME DA REVENDA VEM DA API */}
        {/* 
        <Styled.DrawerHeaderContainer>
          <Styled.LogoMinImg src={logoMin} />
           <Typography variant="h6" noWrap component="div">
            SUPERGASBRAS
          </Typography> 
        </Styled.DrawerHeaderContainer>
          */}
        <Divider />
        {sidebarItems.map((sidebarItem) => {
          if (sidebarItem.isAccordion) {
            return (
              <React.Fragment key={sidebarItem.name}>
                <Styled.AccordionContainer
                  expanded={isSubmenuOpen[sidebarItem.key]}
                >
                  <Styled.AccordionButton
                    expandIcon={<ExpandMoreIcon />}
                    onClick={() =>
                      handleChangeSubmenuVisibility(sidebarItem.key)
                    }
                  >
                    <Styled.AccordionTextContainer>
                      {sidebarItem.icon}
                      <Typography variant="body1" noWrap component="div">
                        {sidebarItem.name}
                      </Typography>
                    </Styled.AccordionTextContainer>
                  </Styled.AccordionButton>
                  <Styled.AccordionItemsContainer>
                    {sidebarItem.items?.map((item, index) => (
                      <React.Fragment key={item.name}>
                        {index === 0 && <Divider />}
                        <Styled.AccordionSubButton
                          to={item.path}
                          isCurrentPage={pathname.includes(item.path)}
                        >
                          <Styled.AccordionTextContainer>
                            <Typography variant="body1" noWrap component="div">
                              {item.name}
                            </Typography>
                          </Styled.AccordionTextContainer>
                        </Styled.AccordionSubButton>
                        {index !== (sidebarItem.items?.length as number) - 1 ? (
                          <Divider />
                        ) : (
                          <div></div>
                        )}
                      </React.Fragment>
                    ))}
                  </Styled.AccordionItemsContainer>
                </Styled.AccordionContainer>
                <Divider />
              </React.Fragment>
            );
          }

          return (
            <React.Fragment key={sidebarItem.name}>
              <Styled.AccordionSubButton
                to={sidebarItem.path}
                isCurrentPage={pathname.includes(sidebarItem.path)}
              >
                <Styled.AccordionTextContainer>
                  {sidebarItem.icon}
                  <Typography variant="body1" noWrap component="div">
                    {sidebarItem.name}
                  </Typography>
                </Styled.AccordionTextContainer>
              </Styled.AccordionSubButton>
              <Divider />
            </React.Fragment>
          );
        })}
      </Styled.DrawerNav>
      <Styled.Main isSidebarMaximized={isSidebarMaximized}>
        <Outlet />
      </Styled.Main>
    </Styled.Container>
  );
};

export default Sidebar;
